/**
 * Empty state for the policy page — shown when no rollout is active. Explains
 * the quarantine→reject journey and lets the customer start a rollout.
 */
import { Loader2 } from "lucide-react";
import { Button } from "@ddmarc/ui";
import { CardV2 } from "@/components/primitives";

export function EmptyState({ onStart, isPending }: { onStart: () => void; isPending: boolean }) {
  return (
    <CardV2
      title="No active rollout"
      subtitle="Move your domain from monitoring to enforcement, one safe stage at a time."
    >
      <div className="space-y-3">
        <p className="text-[12.5px] text-muted-foreground">
          A DMARC policy rollout steps your domain through{" "}
          <code className="font-mono-data text-[11.5px]">p=quarantine</code> and then{" "}
          <code className="font-mono-data text-[11.5px]">p=reject</code>. At each stage we give
          you the exact DNS record to publish, and only let you advance once the safety
          checks pass.
        </p>
        <Button onClick={onStart} disabled={isPending} className="gap-1.5">
          {isPending && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
          Start rollout
        </Button>
      </div>
    </CardV2>
  );
}
